export default function EditTeacherProfile({ handleTeacher, editTeacher }) {
    return (
        <div className="row gy-3 pb-3" style={{background:"rgb(245 241 241)"}}>
            <div className="col-6 col-sm-6">
                <input type="text" name="degree" className="form-control" placeholder="Degree"
                    value={editTeacher.degree} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="experience" placeholder="Experience"
                    value={editTeacher.experience} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="courses" placeholder="Courses"
                    value={editTeacher.courses} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="subject" placeholder="Subject"
                    value={editTeacher.subject} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="language" placeholder="Language"
                    value={editTeacher.language} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="fees" placeholder="Fees"
                    value={editTeacher.fees} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="area" placeholder="Area"
                    value={editTeacher.area} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="district" placeholder="District"
                    value={editTeacher.district} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="state" placeholder="State"
                    value={editTeacher.state} onChange={handleTeacher} />
            </div>
            <div className="col-6 col-sm-6">
                <input type="text" className="form-control" name="pin" placeholder="Pin"
                    value={editTeacher.pin} onChange={handleTeacher} />
            </div>
            <div className="col-12 col-sm-12">
                <textarea className="form-control" name="information" placeholder="Information"
                    value={editTeacher.information} onChange={handleTeacher} />
            </div>
        </div>
    );
}